/* eslint-disable react/no-danger */
import _ from 'lodash';
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { useCountdown } from '@/hooks/useCountdown';
import { isPreviewMode } from '@/utils/tool';
import { FullScreenCtx } from '../fullscreenTipsModule';
export const TooltipFullScreen = props => {
  const {
    attrs
  } = props;
  const {
    autoHidden,
    enable,
    delay,
    content
  } = attrs || {};
  const [, setVisible] = useContext(FullScreenCtx);
  const onFinish = useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  const remain = useCountdown(delay, {
    onFinish: onFinish && !isPreviewMode() ? onFinish : _.noop
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    className: "c-fixed"
  }, /*#__PURE__*/React.createElement(Content, {
    className: "ql-editor",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, "(", remain, "s)")));
};
export default TooltipFullScreen;
const Text = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  /* align-items: center; */
  color: #666666;
  font-size: 14px;
  margin: 20px 0;
`;
const Content = styled.div`
  /* text-align: center; */
`;